<template>
    <div>
        <div v-if="loading" class="pt-5 pl-5">
            <h1>Cargando...</h1>
            
        </div>
        <div v-else-if="activeConsultationInfo" class="vx-row flex justify-center">
            <div class="vx-col vx-col sm:w-4/5 lg:w-2/3 md:w-3/4 px-0 pt-6" style="max-width: 550px">
                <vx-card title="" >

                    <div slot="no-body">
                        <img src="https://evolugy.mayfer.software/Evolugy/app-assets/images/pages/login.png" alt="content-img" class="responsive card-img-top">
                    </div>
                    
                    <div>
                        <div v-if="action == 'newPatient'">
                            <h5>Paciente Nuevo y Confirmación de Consulta</h5>
                            <p class="mt-3 mx-4">¡Hola! Por favor completa la siguiente información para crear tu perfíl y confirma tu primera consulta.</p>
                        </div>
                        <div v-if="action == 'edit'">
                            <h5>Editar Consulta</h5>
                            <p class="mt-3 mx-5">¡Hola! Acá podras editar el motivo, la fecha y hora de tu consulta.</p>
                            <p class="mt-2 mx-5">Para editar presiona en el botón: "Editar Consulta"</p>
                            <p class="mt-2 mx-5">Para anular presiona en el botón: "Anular Consulta"</p>
                        </div>
                        <div v-if="action == 'confirm'">
                            <h5>Confirmar Asistencia</h5>
                            <p class="mt-2 mx-5">Porfavor complementa el motivo de tu consulta para confirmar.</p>
                        </div>
                        <div v-if="action == 'reconfirm'">
                            <h5>Re-Confirmar Asistencia</h5>
                            <p class="mt-2 mx-5">Al Re-Confirmar tu asistencia, confirmas que asistiras a la consulta.</p>
                        </div>
                        
                    </div>

                    <div class="mt-1">
                        <form-wizard color="rgba(var(--vs-primary), 1)"
                            stepSize="sm"
                            :title="null"
                            :subtitle="null"
                            @on-complete="formSubmitted"
                            backButtonText="Regresar"
                            next-button-text="Siguiente"
                            :finishButtonText="action == 'reconfirm' ? 'Re-Confirmar': 'Confirmar'"
                            :startIndex="activeTabIndex"
                        >
                            <tab-content title="Datos del Paciente" class="mb-5" :before-change="validatePatientData">
                                <!-- tab 1 content -->
                                <div v-if="action == 'newPatient'">
                                    <form data-vv-scope="patient-data">
                                        <div class="vx-row">
                                            <div class="vx-col w-full mt-5">
                                                <vs-input label="Nombre(s)" v-model="currentPatientData.first_name"  name="nombres" v-validate="'required'" class="w-full" />
                                                 <span class="text-danger">{{ errors.first('patient-data.nombres') }}</span>
                                            </div>
                                            <div class="vx-col w-full mt-5">
                                                <vs-input label="Apellido(s)" v-model="currentPatientData.last_name" class="w-full" name="apellidos" v-validate="'required'" />
                                                <span class="text-danger">{{ errors.first('patient-data.apellidos') }}</span>
                                            </div>
                                            <div class="vx-col w-full mt-5">
                                                <p>Email</p>
                                                <p class="ml-6 mt-2"> {{currentPatientData.email }} </p>
                                                <small class="ml-6">El correo no puede ser editado. Para cambiar de correo comuníquese con su doctor.</small>
                                            </div>
                                            <div class="vx-col w-full mt-5">
                                                <p>Sexo</p>
                                                <ul class="ml-2 mt-2">
                                                    <li class="ml-3 mb-2">
                                                        <vs-radio v-model="currentPatientData.gender" name="sexo" v-validate="'required'" vs-value="male">
                                                        Másculino
                                                        </vs-radio>
                                                    </li>
                                                    <li class="ml-3 mb-2">
                                                        <vs-radio v-model="currentPatientData.gender" name="sexo" v-validate="'required'" vs-value="female">
                                                        Femenino
                                                        </vs-radio>
                                                    </li>
                                                </ul>
                                                <span class="text-danger">{{ errors.first('patient-data.sexo') }}</span>
                                            </div>
                                            <div class="vx-col  w-full mt-5">
                                                <p>Fecha de Nacimiento</p>
                                                <flat-pickr class="w-full" :config="configdateTimePicker2" v-model="currentPatientData.dob" placeholder="Seleccionar Fecha"
                                                    v-validate="'required'" name="fecha" />
                                                <span class="text-danger w-full">{{ errors.first('patient-data.fecha') }}</span>
                                                <!-- <datepicker 
                                                    class="px-5 mb-4" placeholder="Seleccionar Fecha" format="yyyy-MM-dd" 
                                                    v-model="currentPatientData.dob"
                                                >
                                                </datepicker> -->
                                            </div>
                                            <div class="vx-col  w-full mt-5">
                                                <p>Número de Contacto</p>
                                            </div>
                                            <vs-row vs-type="flex" vs-justify="center">
                                                <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12">
                                                    <!--- <v-select placeholder="Código de Extensión" class="w-1/2" v-model="phoneExt" :options="['502','503', '504', '505']" :dir="$vs.rtl ? 'rtl' : 'ltr'" /> --->
                                                    <vs-input label="Celular" class="px-2 ml-2 w-full" placeholder="Celular" v-model="currentPatientData.phone[0]"/>
                                                </vs-col>
                                            </vs-row>
                                            <div class="vx-col  w-full mt-5">
                                                <p>Identificación</p>
                                            </div>
                                            <vs-row vs-type="flex" vs-justify="center">
                                                <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12">
                                                        <v-select placeholder="Documento" class="w-1/2" v-model="patientMeta.personal_id_type" :options="['DPI','Cédula', 'Pasaporte']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                                         <vs-input label="Identificación" class="ml-2" placeholder="Identificación" 
                                                            v-model="patientMeta.personal_id"
                                                        />
                                                </vs-col>
                                            </vs-row>
                                            <div class="vx-col w-full mt-5">
                                                <h6>Dirección de Residencia</h6>
                                                <vs-input type="text" label="Dirección"  v-model="currentPatientData.address" class="w-full mt-4" />
                                                <vs-input type="text" label="Complemento de Dirección"  v-model="currentPatientData.address_2" class="w-full mt-4" />
                                                <vs-input type="text" label="Zona"  v-model="currentPatientData.zone" class="w-full mt-4" />
                                                <p class="mt-4">País</p>
                                                <v-select placeholder="Selecciona el País" label="name" v-model="currentPatientData.country" class="mt-2" :options="getCountries" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                                <p class="mt-4">Ciudad</p>
                                                <v-select placeholder="Selecciona la ciudad" v-model="currentPatientData.city" class="mt-2" :options="getStates" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                            </div>
                                            <div class="vx-col  w-full mt-6 mb-2">
                                                <h5 class="my-2">¿Cómo encontró al doctor?</h5>
                                                <div class="vx-row ">
                                                    <div class="vx-col flex flex-col items-center w-full">
                                                        <v-select placeholder="Selecciona el origen" class="mt-2 w-full mx-4" 
                                                            :options="['Google','Referidos', 'Redes Sociales', 'Por mi Seguro', 'Ví su clínica', 'Otro']" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="patientMeta.doctorRef"
                                                            />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="vx-col  w-full mt-5" v-if="patientMeta.doctorRef == 'Referidos'">
                                                <p>Persona que lo refirio</p>
                                                <div class="vx-row">
                                                    <div class="vx-col w-1/2">
                                                        <vs-input class="inputx w-full" placeholder="Nombre" v-model="patientMeta.doctorRef_name" />
                                                    </div>
                                                    <div class="vx-col w-1/2 ">
                                                        <vs-input class="inputx w-full" placeholder="Correo" v-model="patientMeta.doctorRef_email" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="vx-col  w-full my-5" v-if="patientMeta.doctorRef == 'Referidos'">
                                                <p>Número de referido</p>
                                                <div class="vx-row">
                                                    <div class="vx-col w-2/3 ">
                                                        <vs-input class="inputx w-full" placeholder="Número de referido" v-model="patientMeta.doctorRef_num" />
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="vx-col  w-full mt-5">
                                                <h5>Hace Ejercicio</h5>
                                                <div class="vx-row ">
                                                    <div class="vx-col">
                                                        <ul class="centerx ml-5 mt-3">
                                                            <li>
                                                                <vs-radio v-model="patientMeta.exercise" :vs-value="true">Si</vs-radio>
                                                            </li>
                                                            <li>
                                                                <vs-radio v-model="patientMeta.exercise" :vs-value="false">No</vs-radio>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div> -->
                                            <div class="vx-col  w-full mt-5" v-if="patientMeta.exercise">
                                                <p>Tipo de ejercicio</p>
                                                <div class="vx-row ">
                                                    <div class="vx-col flex flex-col items-center w-full">
                                                        <v-select placeholder="Tipo de ejercicio" class="mt-2 w-1/2" 
                                                            :options="['Caminar a paso ligero','Caminata regular', 'Trotar', 'Yoga', 'Aerobicos', 'Nadas', 'Bicicleta', 'Correr', 'Otro']" :dir="$vs.rtl ? 'rtl' : 'ltr'" 
                                                            v-model="patientMeta.exerciseType"
                                                            />
                                                    </div>
                                                </div>
                                                <p class="mt-3">¿Con qué frecuencia?</p>
                                                <div class="vx-row ">
                                                    <div class="vx-col flex flex-col items-center w-full">
                                                        <v-select placeholder="Frecuencia de ejercicio" class="mt-2 w-1/2" 
                                                            :options="['Una vez a semana','Dos veces a la semana', 'Tres veces a la semana', 'Cuatro veces a la semana', 'Cinco veces a la semana', 'Seis veces a la semana', 'Todos los días']" :dir="$vs.rtl ? 'rtl' : 'ltr'" 
                                                            v-model="patientMeta.exerciseFreq"
                                                            />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="vx-col w-full mt-2" >
                                                <div class="vx-row mt-5">
                                                    <div class="vx-col w-full">
                                                        <h5>Seguros y planes médicos</h5>
                                                    </div>
                                                </div>
                                                <div class="vx-row mt-5">
                                                    <div class="vx-col w-full">
                                                        <p class="mb-1">Aseguradora o plan médico</p>
                                                        <vs-input class="inputx w-full" placeholder="Aseguradora o plan médico" v-model="patientMeta.insurance_plan" />
                                                    </div>
                                                    <div class="vx-col w-full mt-3">
                                                        <p class="mb-1">Póliza o número de afiliado</p>
                                                        <vs-input class="inputx w-full" placeholder="Póliza o número de afiliado" v-model="patientMeta.insurance_num" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div v-else>
                                    <div class="vx-row">
                                        <div class="vx-col  w-full mt-5">
                                            <h4>Datos del paciente</h4>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Nombres:</h6><p class="inline">
                                                {{currentPatientData.first_name}}
                                            </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Apellidos:</h6><p class="inline">
                                                {{currentPatientData.last_name}}
                                            </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Correo Electrónico:</h6><p class="inline">
                                                {{currentPatientData.email}}
                                            </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Sexo:</h6><p class="inline">
                                                {{currentPatientData.gender == "male" ? "Másculino" : "Femenino" }}
                                            </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="currentPatientData.dob">
                                            <h6 class="inline mr-2">Fecha de Nacimiento:</h6>
                                            <p class="inline">
                                                {{ currentPatientData.dob ? 
                                                new Date(currentPatientData.dob).toLocaleDateString('es-ES', dateStringOptions) :
                                                ''
                                                }}
                                            </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="currentPatientData.meta && currentPatientData.meta.blood_type">
                                            <h6 class="inline mr-2">Tipo de Sangre:</h6>
                                            <p class="inline">
                                               {{ currentPatientData.meta && currentPatientData.meta.blood_type ? 
                                                    currentPatientData.meta.blood_type :
                                                    ' '
                                                }}
                                            </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="currentPatientData.meta && currentPatientData.meta.height">
                                            <h6 class="inline mr-2">Estatura:</h6>
                                            <p class="inline">
                                                {{ currentPatientData.meta && currentPatientData.meta.height ? 
                                                    currentPatientData.meta.height+' Metros' :
                                                    ''
                                                }}
                                            </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="currentPatientData.meta && currentPatientData.meta.weight">
                                            <h6 class="inline mr-2">Peso:</h6>
                                            <p class="inline">
                                               {{ currentPatientData.meta && currentPatientData.meta.weight ? 
                                                    currentPatientData.meta.weight+' Libras' :
                                                    ' '
                                                }}
                                            </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="currentPatientData.meta && currentPatientData.meta.personal_id">
                                            <h6 class="inline mr-2">Identificación:</h6>
                                            <p class="inline">
                                                {{ currentPatientData.meta && currentPatientData.meta.personal_id_type ? 
                                                    currentPatientData.meta.personal_id_type :
                                                    ' '
                                                }}
                                               {{ currentPatientData.meta && currentPatientData.meta.personal_id ? 
                                                    currentPatientData.meta.personal_id :
                                                    ' '
                                                }}
                                            </p>
                                        </div>
                                        <vs-divider></vs-divider>                                    
                                    </div>
                                </div>
                            </tab-content>

                            <!-- tab - antecedentes -->
                            <tab-content v-if="action=='newPatient'" title="Antecedentes" class="mb-5" :before-change="validatePatientAnt">
                                <form data-vv-scope="patient-ant">
                                    <div class="vx-row mb-5">
                                        <div class="vx-col w-full">
                                            <h5>Ficha del Paciente</h5>
                                        </div>
                                    </div>
                                    <div class="vx-row">
                                        <div class="vx-col flex flex-col w-1/4 pl-2">
                                            <p>Alergías</p>
                                            <vs-switch color="success" class="mt-3 ml-4" v-model="patientMeta.allergyBool">
                                                <span slot="on">Si </span>
                                                <span slot="off">No</span>
                                            </vs-switch>
                                        </div>
                                        <div class="vx-col flex flex-col w-3/4" v-if="patientMeta.allergyBool">
                                            <vs-textarea v-model="patientMeta.allergyVal" label="Detalle Alergías"  v-validate="'required'" name="alergias" class="ml-5 inline" rows="1" />
                                            <span class="text-danger w-full">{{ errors.first('patient-ant.alergias') }}</span>
                                        </div>
                                    </div>
                                    <div class="vx-row mt-4 ">
                                        <div class="vx-col flex flex-col w-1/4 pl-2">
                                            <p>Enfermedades</p>
                                            <vs-switch color="success" class="mt-3 ml-4" v-model="patientMeta.conditionBool">
                                                <span slot="on">Si </span>
                                                <span slot="off">No</span>
                                            </vs-switch>
                                        </div>
                                        <div class="vx-col flex flex-col w-3/4" v-if="patientMeta.conditionBool">
                                            <vs-textarea v-model="patientMeta.conditionVal" label="Detalle Enfermedades" v-validate="'required'" name="enfermedades" class="ml-5 inline" rows="1" />
                                            <span class="text-danger w-full">{{ errors.first('patient-ant.enfermedades') }}</span>
                                        </div>
                                    </div>
                                    <div class="vx-row mt-4">
                                        <div class="vx-col w-full pl-2">
                                            <p>¿Utiliza medicamentos?</p>
                                        </div>
                                    </div>
                                    <div class="vx-row ">
                                        <div class="vx-col flex flex-col w-1/4 pl-2">
                                            <vs-switch color="success" class="mt-3 ml-4" v-model="patientMeta.MedsBool">
                                                <span slot="on">Si </span>
                                                <span slot="off">No</span>
                                            </vs-switch>
                                        </div>
                                        <div class="vx-col flex flex-col w-3/4" v-if="patientMeta.MedsBool">
                                            <vs-textarea v-model="patientMeta.MedsVal" label="Detalle Medicamentos" v-validate="'required'" name="medicamentos" class="ml-5 inline" rows="1" />
                                            <span class="text-danger w-full">{{ errors.first('patient-ant.medicamentos') }}</span>
                                        </div>
                                    </div>
                                    <div class="vx-row mt-4">
                                        <div class="vx-col w-full pl-2">
                                            <p>Antecedentes de Cáncer en la familia</p>
                                        </div>
                                    </div>
                                    <div class="vx-row ">
                                        <div class="vx-col flex flex-col w-1/4 pl-2">
                                            <vs-switch color="success" class="mt-3 ml-4" v-model="patientMeta.cancerBool">
                                                <span slot="on">Si </span>
                                                <span slot="off">No</span>
                                            </vs-switch>
                                        </div>
                                        <div class="vx-col flex flex-col w-3/4" v-if="patientMeta.cancerBool">
                                            <vs-textarea v-model="patientMeta.cancerVal" label="Detalle Antecedentes de Cancer" v-validate="'required'" name="cancer" class="ml-5 inline" rows="1" />
                                            <span class="text-danger w-full">{{ errors.first('patient-ant.cancer') }}</span>
                                        </div>
                                    </div>
                                    <div class="vx-row mt-4 ">
                                        <div class="vx-col flex flex-col w-1/4 pl-2">
                                            <p>Cirugías</p>
                                            <vs-switch color="success" class="mt-3 ml-4" v-model="patientMeta.surgeryBool">
                                                <span slot="on">Si </span>
                                                <span slot="off">No</span>
                                            </vs-switch>
                                        </div>
                                        <div class="vx-col flex flex-col w-3/4" v-if="patientMeta.surgeryBool">
                                            <vs-textarea v-model="patientMeta.surgeryVal" label="Detalle Cirugías"  v-validate="'required'" name="cirugias" class="ml-5 inline" rows="1" />
                                            <span class="text-danger w-full">{{ errors.first('patient-ant.cirugias') }}</span>
                                        </div>
                                    </div>                                
                                    <div class="vx-row mt-4">
                                        <div class="vx-col lg:w-1/4 sm:w-full md:w-1/3">
                                            <p>¿Usted fuma?</p>
                                            <ul class="centerx ml-5 mt-3 flex">
                                                <li class="inline mr-4">
                                                    <vs-radio v-model="patientMeta.smoke" name="smoke" :vs-value="true">Si</vs-radio>
                                                </li>
                                                <li>
                                                    <vs-radio v-model="patientMeta.smoke" name="smoke" :vs-value="false">No</vs-radio>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="vx-col lg:w-3/4 sm:w-full md:w-2/3" v-if="patientMeta.smoke">
                                            <p>Si fuma, cuantos cigarros al día y desde hace cuento tiempo</p>
                                            <vs-textarea v-model="patientMeta.smokeDetail" v-validate="'required'" name="detalle_fumador" class="" rows="1" />
                                            <span class="text-danger w-full">{{ errors.first('patient-ant.detalle_fumador') }}</span>
                                        </div>
                                    </div>
                                    <div class="vx-row mt-4 ">
                                        <div class="vx-col flex flex-col w-1/2 pl-2">
                                            <p class="mb-2">Grupo sanguineo</p>
                                            <div class="flex ml-4 w-full">
                                                <v-select :options="['A+','O+','AB+','A-','O-','B-','B+','AB-']" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" 
                                                    v-model="patientMeta.blood_type" class="mb-4 md:mb-0 inputx w-full" 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vx-row mt-4 ">
                                        <div class="vx-col flex flex-col w-1/2 pl-2">
                                            <p class="mb-2">Peso (Libras)</p>
                                            <div class="flex ml-4 w-full">
                                                <vs-input class="inputx w-full" placeholder="Peso (Libras)" v-model="patientMeta.weight" />
                                            </div>
                                        </div>
                                        <div class="vx-col flex flex-col w-1/2 pl-2">
                                            <p class="mb-2">Estatura (Metros)</p>
                                            <div class="flex ml-4 w-full">
                                                <vs-input class="inputx w-full" placeholder="Estatura (Metros)" v-model="patientMeta.height" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vx-row mt-4 ">
                                        <div class="vx-col  w-full pl-2">
                                            <p>Hace Ejercicio</p>
                                            <div class="vx-row">
                                                <div class="vx-col">
                                                    <ul class="centerx ml-5 mt-3 flex">
                                                        <li class="inline mr-2">
                                                            <vs-radio v-model="patientMeta.exercise" name="exercise" :vs-value="true">Si</vs-radio>
                                                        </li>
                                                        <li>
                                                            <vs-radio v-model="patientMeta.exercise" name="exercise" :vs-value="false">No</vs-radio>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="vx-col  w-full mt-4" v-if="patientMeta.exercise">
                                            <p>Tipo de ejercicio</p>
                                            <div class="vx-row ">
                                                <div class="vx-col flex flex-col items-center w-full">
                                                    <v-select placeholder="Tipo de ejercicio" class="mt-1 w-full"  v-model="patientMeta.exerciseType"
                                                        :options="['Caminar a paso ligero','Caminata regular', 'Trotar', 'Yoga', 'Aerobicos', 'Nadas', 'Bicicleta', 'Correr', 'Otro']" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                                        />
                                                </div>
                                            </div>
                                            <div class="vx-row mt-4 ">
                                                <div class="vx-col w-full">
                                                <p>¿Con qué frecuencia?</p>
                                                </div>
                                            </div>
                                            
                                            <div class="vx-row">
                                                <div class="vx-col w-full">
                                                    <v-select placeholder="Frecuencia de ejercicio" class="mt-1 w-full"  v-model="patientMeta.exerciseFreq"
                                                        :options="['Una vez a semana','Dos veces a la semana', 'Tres veces a la semana', 'Cuatro veces a la semana', 'Cinco veces a la semana', 'Seis veces a la semana', 'Todos los días']" 
                                                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                                        />
                                                </div>
                                                <div class="vx-col w-full mt-4">
                                                    <p>Tiempo (min)</p>
                                                    <vs-input class="inputx w-full" placeholder="Tiempo (min)" v-model="patientMeta.exerciseTime" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </tab-content>

                            <!-- tab 2 content -->
                            <tab-content title="Cita Médica" class="mb-5" :before-change="validateCitaMed">
                                <form data-vv-scope="cita-med">
                                <div class="vx-row">
                                    <div class="vx-col  w-full mt-5">
                                        <h6>Motivo de la Consulta</h6>
                                    </div>
                                    <div class="vx-col  w-full mt-5">
                                        <p>Explique todos los síntomas y/o motivos para su consulta.</p>
                                    </div>
                                    <div class="vx-col sm:w-full md:w-2/3 w-full">
                                        <vs-textarea v-model="consultationDetail.comments_obs" label="Descripción del Motivo de Consulta" v-validate="'required'" name="motivo_consulta" class="mb-0 md:mt-10 mt-6" rows="3" />
                                        <span class="text-danger w-full">{{ errors.first('cita-med.motivo_consulta') }}</span>
                                        <small class="w-full" v-if="action == 'confirm'"><br>Para confirmar la reserva debe indicar un motivo de consulta.</small>
                                    </div>
                                    
                                    <div class="vx-col sm:w-full md:w-1/3 pt-3 w-full">
                                        <h6>Síntomas COVID</h6>
                                        <ul class="centerx ml-4">
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.fever">Fiebre</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.dryCough">Tos Seca</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.tiredness">Cansancio</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.throatPain">Dolor de Garganta</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.diarrhea">Diarrea</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.headache">Dolor de Cabeza</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.smellTasteLoss">Perdida del sentido del olfato o del gusto</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.breathingDifficulty">Dificultad para respirar</vs-checkbox>
                                            </li>
                                            <!-- <li>
                                                <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.pressure">Presión alta</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.fever">Fiebre</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.nausea">Nausea</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.tiredness">Cansancio</vs-checkbox>
                                            </li>
                                            <li>
                                                <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.fatigue">Fatiga</vs-checkbox>
                                            </li> -->
                                        </ul>
                                    </div>
                                    <vs-divider></vs-divider>
                                    <!-- Preguntas dinamicas start -->
                                    <vs-row vs-w="12">
                                        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="6">
                                        <h5>Preguntas Personalizadas</h5>
                                        </vs-col>
                                    </vs-row>
                                    <vs-row vs-w="12" v-for="(question, key) in userQuestions" :key="key" class="mt-2" >
                                        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="12" v-if="question.active">
                                        <div class="vx-col w-full">
                                            <p>{{question.title}}</p>
                                            <vs-textarea v-model="customQuestionsAnswers[key]" :label="question.instructions" class="mb-3" rows="1" />
                                        </div>
                                        </vs-col>
                                    </vs-row>
                                    <!-- preguntas dinamicas - end -->

                                    <!-- <div class="vx-col  w-full mt-6">
                                        <h4 class="my-4">Datos de la Cita Médica</h4>
                                    </div> -->

                                    <div class="vx-col sm:w-full py-6 w-full flex flex-col items-center">
                                        <!-- <h6><code class="text-primary">
                                                {{new Date(activeConsultationInfo.date).toLocaleDateString('es-ES', dateStringOptions)}}
                                                -
                                                {{new Date(activeConsultationInfo.date).toLocaleTimeString('en-EN', timeStringOptions)}}
                                            </code>
                                        </h6>
                                        <vs-divider/> -->
                                        <!-- <calendar
                                            class="mt-6"
                                            title-position="left"
                                            locale="es"
                                            :attributes="miniCalendar"
                                        ></calendar> -->

                                    </div>
                                    <div class="vx-col  w-full mt-5" v-if="action == 'newPatient' && false">
                                        <h5>¿Es cita de control a una consulta anterior?</h5>
                                        <div class="vx-row ">
                                            <div class="vx-col">
                                                <ul class="centerx ml-5 mt-3">
                                                    <li>
                                                        <vs-radio v-model="consultationDetail.prev_consultation_control" name="prev_consultation_control" :vs-value="true">Si</vs-radio>
                                                    </li>
                                                    <li>
                                                        <vs-radio v-model="consultationDetail.prev_consultation_control" name="prev_consultation_control" :vs-value="false">No</vs-radio>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </form>
                            </tab-content>

                            <!-- tab 3 content -->
                            <tab-content title="Resumen" class="mb-5">
                                <div class="vx-row">
                                    <div class="vx-col  w-full mt-5">
                                        <h5>Datos del Paciente</h5>
                                        <p class="mt-2">
                                            {{currentPatientData.first_name}} {{currentPatientData.last_name}}
                                        </p>
                                        <p class="mt-2">
                                            {{currentPatientData.email}}
                                        </p>
                                    </div> 
                                    <div class="vx-col  w-full mt-5">
                                        <h5>Datos del Doctor</h5>
                                        <p class="mt-2">
                                            {{currentDoctorData.first_name}} {{currentDoctorData.last_name}}
                                        </p>
                                        <p class="mt-2">
                                            {{currentDoctorData.email}}
                                        </p>
                                    </div>                                    
                                </div>
                                <vs-divider></vs-divider>
                                <div class="vx-row">
                                    <div class="vx-col  w-full mt-5">
                                        <h5>Fecha y hora de la consulta</h5>
                                    </div>
                                    <div class="vx-col  w-full mt-5" v-if="!edit">
                                        <p class="mt-2">
                                            {{new Date(activeConsultationInfo.date).toLocaleDateString('es-ES', dateStringOptions)}}
                                                -
                                            {{new Date(activeConsultationInfo.date).toLocaleTimeString('en-EN', timeStringOptions)}}
                                        </p>
                                    </div>
                                    <div class="vx-col  w-full mt-5" v-else>
                                        <div class="vx-row w-full mt-3">
                                            <div class="vx-col w-1/3">
                                            <p class="ml-3">Fecha<p/>
                                            </div>
                                            <div class="vx-col w-2/3">
                                                <flat-pickr class="w-full" :config="configdateTimePicker" v-model="editEventData.date" placeholder="Fecha y Hora"
                                                v-validate="'required'" name="fecha_hora" />
                                                <span class="text-danger w-full">{{ errors.first('new-event.fecha_hora') }}</span>
                                            </div>
                                        </div>
                                        <div class="vx-row w-full mt-3">
                                            <div class="vx-col w-1/3">
                                            <p class="ml-3">Hora<p/>
                                            </div>
                                            <div class="vx-col w-2/3">
                                                <v-select v-if="editEventData.date" :options="availability" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                                name="hora" v-validate="'required'" class="w-full"  v-model="editEventData.hour" ref="hora" />
                                                <p class="my-1" v-else >Selecciona una fecha</p>
                                                <span class="text-danger">{{ errors.first('new-event.hora') }}</span>
                                            </div>
                                        </div>
                                        <div class="vx-row w-full mt-3">
                                            <div class="vx-col w-1/3">
                                            <p class="ml-3">Clínica<p/>
                                            </div>
                                            <div class="vx-col w-2/3">
                                                <v-select class="w-full" :options="docClinics" label="title" 
                                                v-validate="'required'"  name="clinica" 
                                                :reduce="option => option.id"  v-model="editEventData.clinic_id" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                                :selectable="option => !(option.meta.zoom_active && option.meta.zoom_active.toLowerCase() == 'false')"
                                                >
                                                    <template v-slot:option="option">
                                                        <img class="mr-2 inline"  :src=" option.meta.type.toLowerCase() == 'virtual' ? 
                                                        'https://img.icons8.com/ios/24/000000/zoom.png' :
                                                        'https://img.icons8.com/material-outlined/24/000000/hospital-3.png' "/>
                                                        <p class="inline"
                                                        :class="(option.meta.type.toLowerCase() == 'virtual') && (option.meta.zoom_active) && !(option.meta.zoom_active == 'true')
                                                            ? 'text-danger' : 'text-primary'"
                                                        >{{ 
                                                        (option.meta.type.toLowerCase() == 'virtual')
                                                        && (option.meta.zoom_active) && !(option.meta.zoom_active == 'true')
                                                        ?  `${option.title} - Sin Activar` : option.title
                                                        }}</p>
                                                    </template>
                                                </v-select> 
                                                <span class="text-danger">{{ errors.first('new-event.clinic') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col  w-full mt-5">
                                        <h5>Motivo de la Consulta</h5>
                                    </div>
                                    <div class="vx-col  w-full mt-5" v-if="!edit">
                                        <p> {{consultationDetail.comments_obs}} </p>
                                    </div>
                                    <div class="vx-col  w-full mt-5" v-else>
                                        <vs-textarea v-model="consultationDetail.comments_obs"></vs-textarea>
                                    </div>
                                </div>
                                 <div class="vx-row mt-3" v-if="action !== 'newPatient'">
                                     <!-- <div class="vx-col w-full items-center mt-5" v-if="action == 'confirm' && !edit">
                                       <vs-button color="success" size="normal" type="filled" @click="confirmConsultation">Confirmar</vs-button>
                                       <vs-divider></vs-divider>
                                    </div> -->
                                    <div class="vx-col w-full items-center mt-5" v-if="!edit">
                                       <vs-button color="warning" size="small" type="filled" @click="edit = !edit">Editar Consulta</vs-button>
                                    </div>
                                    <div class="vx-col w-full items-center mt-5" v-if="edit">
                                        <vs-button color="success" class="mr-3" size="normal" type="filled" @click="editConsultation">Guardar</vs-button>
                                        <vs-button color="warning"  size="small" type="filled" @click="edit = !edit">Cancelar</vs-button>
                                    </div>
                                    <vs-divider></vs-divider>
                                    <div class="vx-col w-full items-center mt-5">
                                       <vs-button color="danger" size="small" type="filled" @click="$modal.show('confirmCancelModal');">Anular Consulta</vs-button>
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col w-full mt-5 flex flex-col items-center">
                                        <!-- <h6 class="my-3">Agregar Recordatorio</h6> -->
                                    </div>
                                </div>
                                <div class="vx-row">

                                </div>
                            </tab-content>

                        </form-wizard>
                    </div>
                    <modal
                    name="confirmCancelModal"
                    height="auto"
                    width="90%"
                    :scrollable="true"
                    style="z-index: 1005;"
                    >
                        
                        <div class="vx-row p-3">
                            <div class="vx-col w-full mt-3">
                                <h5>¿Está seguro que desea anular la consulta?</h5>
                            </div>
                            <div class="vx-col w-full my-6">
                                <vs-button color="danger" size="normal" type="filled" @click="cancelConsultation">Si, deseo anular la consulta.</vs-button>
                            </div>
                            <div class="vx-col w-full mb-4">
                                <vs-button color="primary" size="normal" type="filled" @click="$modal.hide('confirmCancelModal');">No, regresar.</vs-button>
                            </div>
                        </div>
                    </modal>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import moment from 'moment'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
const ES = require("flatpickr/dist/l10n/es.js").default.es;

// country state picker functions
import * as CSP from 'country-state-picker';


export default {
  data () {
    return {
      areaCodes: ["501", "502", "503", "504", "505", "506", "507"],
      userQuestions: [],
      customQuestionsAnswers: [],
      phoneExt: null,
      edit: false,
      loading: true, 
      doctor_id: null,
      activeTabIndex: null,
      action: null,
      patientMeta: {
        height: null,
        weight: null,
        blood_type: null,
        personal_id: null,
        personal_id_type: null,
        insurance_num: null,
        insurance_plan: null,
        doctorRef: null,
        doctorRef_name: null,
        doctorRef_email: null,
        doctorRef_num: null,
        exercise: null,
        exerciseFreq: null,
        exerciseType: null,
        exerciseTime: null,
        allergyBool: null,
        allergyVal: null,
        conditionBool: null,
        conditionVal: null,
        MedsBool: null,
        MedsVal: null,
        cancerBool: null,
        cancerVal: null,
        surgeryBool: null,
        surgeryVal: null,
        smokeDetail: null,
        smoke: null



      },
      editEventData: {
        eventType: 'consulta',
        title: null,
        notes: null,
        duration: 60,
        notification: true,
        date: null,
        timeType: 'normal',
        clinic_id: null,
        patient_id: null,
        doctor_id: null,
        zoom_email: null,
        zoom_jwt: null,
        clinicType: 'presencial',
        hour: ""
        
      },
      currentPatientData: {},
      currentDoctorData: {},
      dateStringOptions:  { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      timeStringOptions:  { hour: 'numeric', minute: 'numeric', hour12: true },
        miniCalendar: [
            {
            key: 'Hoy',
            highlight: true,
            dates: new Date(),
            readonly: true,
            }
      ],
     consultationDetail: {
        comments_obs: null,
        diseases: [],
        medicaments: [],
        evaluationQuestions: [],
        importantNotes: null,
        physical_exam: null,
        vitalSigns: [],
        vitalSignsArr: [],
        physical_notes: null,
        documents: [],
        cie10: [],
        exams: [],
        meds: [],
        usedMeds: [],
        diagnosis_eval: null,
        nextConsultation: {
          requestNext: false,
          whenQty: null,
          whenFrq: null,
        },
        consultationTotal: 250.00,
        paymentMethod: null,
        main_symptoms: {
          pressure: false,
          fever: false,
          nausea: false,
          tiredness: false,
          fatigue: false
        },
        prev_consultation_control: false,
      },
      origen: '',
      exercise: {
          yof: true,
          type: ''
      },
      configdateTimePicker: {
        enableTime: false,
        dateFormat: 'm-d-Y',
        altInput: true,
        altFormat: 'd M Y',
        defaultDate: new Date(),
        minDate: new Date(),
        locale: ES
      },
      configdateTimePicker2: {
        enableTime: false,
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd M Y',
        defaultDate: new Date(),
        locale: ES
      },
      
    }
  },
  methods: {
    openLoading(){
      this.$vs.loading()
      setTimeout( ()=> {
        this.$vs.loading.close()
      }, 15000);
    },
    verifyNumber(number) {
        var patient_phone = this.areaCodes.includes(number.substring(0, 2)) ? number : '502' + number;
        return patient_phone
    },
    confirmConsultation(action){
        let newStatus;
        if(action = 'reconfirm'){
            newStatus = 'Re-Confirmada';
        } else {
            newStatus = 'Confirmada';
        }
        var customQuestions = new Array();
            for (let index = 0; index < this.userQuestions.length; index++) {
                let tempObj = new Object();
                tempObj.name = this.userQuestions[index].name;
                tempObj.title = this.userQuestions[index].title;
                tempObj.instructions = this.userQuestions[index].placeholder;
                tempObj.active = this.userQuestions[index].active;
                tempObj.answer = this.customQuestionsAnswers[index];
                customQuestions.push(tempObj);
        }
        var payload = new Object(); 
            payload.event_id = this.activeConsultationInfo.id;
            payload.meta = {
                ...this.activeConsultationInfo.meta, ...this.consultationDetail,
                ...{"status": newStatus}, ...{'customQuestions': customQuestions}
            };
            this.openLoading();
        this.$store.dispatch('editEventPublic', payload).then(response => {
                
            console.log('response: ',response);
            
            this.$store.dispatch('notifyConfirmSuccess', response).then((response2) => {
            //   window.location.href = '/links/confirm-s';  
                // --- notif payload ---
                var notifPayload = JSON.stringify(
                    {
                    "type":"push",
                    "title":"Consulta  #"+response.data.data.event.id+" confirmada!",
                    "message": `La consulta #${response.data.data.event.id} fue confirmada por el paciente`,
                    "target":{
                        "id":{"$eq":""+response.data.data.event.doctor_id+""}
                        }
                });
                // ---------------------
                if(this.action == 'reconfirm'){
                     this.$store.dispatch('notifyReConfirmationSuccessPublic', response.data.data.event).then((response2) => {
                        window.location.href = '/links/confirm-s';  
                    }).catch((error) => { 
                        window.location.href = '/links/confirm-s';  
                        console.log('WATCH - ERROR');
                        reject(error);
                        
                    });
                    
                } else {
                    this.$store.dispatch('sendNotificationPublic', notifPayload).then((response2) => {
                        window.location.href = '/links/confirm-s';  
                    }).catch((error) => { 
                        window.location.href = '/links/confirm-s';  
                        console.log('WATCH - ERROR');
                        reject(error);
                    });
                }  
                
                
            }).catch((error) => { reject(error) });

        }, error => {
            console.error(error.response);
            
        });
    },
    validatePatientAnt(){
       return new Promise((resolve, reject) => {
            this.$validator.validateAll('patient-ant').then(result => {
                if (result) {
                    resolve(true);
                    this.scroll();
                } else {
                    reject('correct all values')
                }
            })
        }); 
    },
    validateCitaMed(){
        return new Promise((resolve, reject) => {
            this.$validator.validateAll('cita-med').then(result => {
                if (result) {
                    resolve(true);
                    this.scroll()
                } else {
                    reject('correct all values')
                }
            })
        });
    },
    validatePatientData(){
        return new Promise((resolve, reject) => {
            this.$validator.validateAll('patient-data').then(result => {
                if (result) {
                    resolve(true);
                    this.scroll()
                } else {
                    this.scrollTop()
                    reject('correct all values')
                }
            })
        });
    },
    scroll(){
       window.scroll({
        top: 130,
        left: 0,
        behavior: 'smooth'
      });
    },
    scrollTop(){
       window.scroll({
        top: 150,
        left: 0,
        behavior: 'smooth'
      });
    },
    findZoomClinicsActive(){
      let zoomClinics = this.$store.state.clinics.filter(obj => {
        return ( obj.meta.type && obj.meta.type.toLowerCase() == 'virtual' )
          
          && (obj.meta.zoom_email)
          && (obj.meta.zoom_active && obj.meta.zoom_active.toLowerCase() == 'true');

      });
      console.log(zoomClinics);
      return zoomClinics
    },
    getSchedule(currentDate) {
      let day = moment(currentDate, 'MM-DD-YYYY').day();
      // day = day == 0 ? 7 : day;
      const weekDays = this.getWeekDays();
      return weekDays ? weekDays.find(item => item.id ==day) : null;
    },
    getWeekDays() {
      console.log(this.currentDoctorData);
      if(this.currentDoctorData) {
        if(this.currentDoctorData.meta && this.currentDoctorData.meta.weekDays) {
          const weekDays = this.currentDoctorData.meta.weekDays;
          return Array.isArray(weekDays) ? weekDays : null
        }
      }
      return [];
    },
    getFormattedDate(date) {
      var year = date.getFullYear();

      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;

      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;
      
      return month + '-' + day + '-' + year;
    },
    formSubmitted () {
        if(this.action == 'confirm'){
            this.confirmConsultation('confirm');
        } else if(this.action == 'reconfirm'){
            this.confirmConsultation('reconfirm');
        } else {
            this.editPatientEvent();
        }
      
    },
    cancelConsultation(){
        this.openLoading();
        var payload = new Object(); 
            payload.event_id = this.activeConsultationInfo.id;
            payload.meta = {...this.activeConsultationInfo.meta, ...this.consultationDetail, ...{"status": "Anulada"}};
            
            this.$store.dispatch('editEventPublic', payload).then(response => {
                this.showAlert('success','Evento Actualizado','Evento actualizado exitosamente');
                
                console.log(response);
                
                // --- notif payload ---
                var notifPayload = JSON.stringify(
                    {
                    "type":"push",
                    "title":"La consulta #"+response.data.data.event.id+" fue anulada!",
                    "message": `La consulta #${response.data.data.event.id} fue anulada por el paciente ${this.currentPatientData.first_name} ${this.currentPatientData.last_name} con ID #${this.currentPatientData.id}`,
                    "target":{
                        "id":{"$eq":""+response.data.data.event.doctor_id+""}
                        }
                
                });
                var doctor_phone = this.verifyNumber(this.currentDoctorData.phone[0]);
                var notifPayloadWA = JSON.stringify(
                    {
                    "type":"whatsapp",
                    "title":"La consulta #"+response.data.data.event.id+" fue anulada!",
                    "message": `La consulta #${response.data.data.event.id} fue anulada por el paciente ${this.currentPatientData.first_name}${this.currentPatientData.last_name} con ID #${this.currentPatientData.id}`,
                    "meta":{
                        "to": doctor_phone
                        },
                    "url": ''
                
                });
                // ---------------------
                this.$store.dispatch('sendNotificationPublic', notifPayloadWA)
                this.$store.dispatch('sendNotificationPublic', notifPayload).then((response2) => {
                 setTimeout(() => {
                        window.location.href = '/links/confirm-an';  
                    }, 800);
                }).catch((error) => { reject(error) });
                      
            }, error => {
                console.error(error.response);
                
            });
    },
    editConsultation(){
        this.openLoading();
        var payload = new Object(); 
            payload.event_id = this.activeConsultationInfo.id;
            // payload.meta = {
            //     ...this.activeConsultationInfo.meta, ...this.consultationDetail, ...{"status": "Anulada"}
            // };
            payload.clinic_id = this.editEventData.clinic_id;
            
            try {
                var tempDate = new Date(this.editEventData.date.replace(/-/g, "/"));
            } catch (error) {
                var tempDate = new Date(this.editEventData.date);
                console.error(error);
            }

            tempDate.setHours(this.editEventData.hour.split(':')[0],this.editEventData.hour.split(':')[1].substring(0,2));
            // payload.date = tempDate.toISOString();
            payload.date = tempDate.getFullYear()+ "-" + ("00" + (tempDate.getMonth() + 1)).slice(-2) + "-" +("00" + tempDate.getDate()).slice(-2)+"T"+ ("00" + tempDate.getUTCHours()).slice(-2) + ":" +("00" + tempDate.getUTCMinutes()).slice(-2) + ":" + ("00" + tempDate.getSeconds()).slice(-2)
            
            this.$store.dispatch('editEventPublic', payload).then(response => {
                 this.showAlert('success','Evento Actualizado','Evento actualizado exitosamente');
                console.log(response);
                this.$store.dispatch('notifyEditSuccess', response).then((response2) => { // DONE
                    console.log(response2);
                }).catch((error) => { reject(error) });

                // --- notif payload ---
                var notifPayload = JSON.stringify(
                    {
                    "type":"push",
                    "title":"La consulta  #"+response.data.data.event.id+" fue editada!",
                    "message": `La consulta #${response.data.data.event.id} fue editada por el paciente 
                        ${this.currentPatientData.first_name} ${this.currentPatientData.last_name} con ID #${this.currentPatientData.id}`,
                    "target":{
                        "id":{"$eq":""+response.data.data.event.doctor_id+""}
                        }
                });
                // -------------------
                // ---- send push ----
                this.$store.dispatch('sendNotificationPublic', notifPayload).then((response2) => {
                  setTimeout(() => {
                        window.location.href = '/links/confirm-ed';  
                    }, 800);
                }).catch((error) => { reject(error) });
                // ---- push end ----
                      
            }, error => {
                console.error(error.response);
                
            });
    },
    editPatientEvent(){
        this.openLoading();
      this.editting = !this.editting;
      var patientDOB = new Date(this.currentPatientData.dob);
      patientDOB.setDate(patientDOB.getDate() + 1)

      console.log(this.patientMeta);
      console.log(this.patientData);
      this.currentPatientData.active = true;
      this.currentPatientData.dob = patientDOB.toISOString().split('T')[0]
      this.currentPatientData.phone[0] = this.currentPatientData.phone[0]; 
      this.currentPatientData.country = this.currentPatientData.country.name;
      this.currentPatientData.meta = {...this.currentPatientData.meta ,...this.patientMeta};

        this.$store.dispatch('editUserPublic', this.currentPatientData).then(response => {
            this.showAlert('success','Datos actualizados','Datos del paciente actualizados exitosamente');
            // console.log(response);
            
            // custom questions container
            var customQuestions = new Array();
            for (let index = 0; index < this.userQuestions.length; index++) {
                let tempObj = new Object();
                tempObj.name = this.userQuestions[index].name;
                tempObj.title = this.userQuestions[index].title;
                tempObj.instructions = this.userQuestions[index].placeholder;
                tempObj.active = this.userQuestions[index].active;
                tempObj.answer = this.customQuestionsAnswers[index];
                customQuestions.push(tempObj);
            }
            // end - custom questions
            var payload = new Object(); 
            payload.event_id = this.activeConsultationInfo.id;
            payload.meta = {
                    ...this.activeConsultationInfo.meta, ...this.consultationDetail, 
                    ...{"status": "Confirmada"}, ...{'customQuestions': customQuestions}
                };
            

            this.$store.dispatch('editEventPublic', payload).then(response => {
                this.showAlert('success','Evento Actualizado','Evento actualizado exitosamente');
                this.$store.dispatch('notifyConfirmSuccess', response).then((response2) => {
                  console.log(response2);
                }).catch((error) => { reject(error) });

                 // --- notif payload ---
                var notifPayload = JSON.stringify(
                    {
                    "type":"push",
                    "title":"La consulta  #"+response.data.data.event.id+" fue confirmada!",
                    "message": `La consulta #${response.data.data.event.id} fue confirmada por el paciente 
                        ${this.currentPatientData.first_name} ${this.currentPatientData.last_name} con ID #${this.currentPatientData.id}`,
                    "target":{
                        "id":{"$eq":""+response.data.data.event.doctor_id+""}
                        }
                });
                // -------------------
                // ---- send push ----
                this.$store.dispatch('sendNotificationPublic', notifPayload).then((response2) => {
                  setTimeout(() => {
                        window.location.href = '/links/confirm-s';  
                    }, 800);
                }).catch((error) => { reject(error) });
                // ---- push end ----
      
            }, error => {
                console.error(error.response);
                
            });
                        
        }, error => {
            console.error(error.response);
            
        });
    },
    showAlert (color,title,text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text
      })
    }
  },
  computed: {
    docClinics () {
      let currentClinics = this.$store.state.clinics;
      console.log('CLINICAS:',currentClinics);
      // obtener clinicas virtuales de zoom y que esten activas
      var zoomClinics = this.findZoomClinicsActive();

      if (zoomClinics.length > 0){
        return currentClinics;
      } else {
        // si no ha activado 
        // let defaultVirtual = new Object();
        // defaultVirtual.title = 'Clinica Virtual Zoom',
        // defaultVirtual.meta = {"type":"Virtual", "zoom_active":"false"}
        // return [defaultVirtual, ...currentClinics];
        return currentClinics;
      }
    },
    availability (){
        console.log(this.$store.state.schedule);
      return this.$store.state.schedule
    },
    activeConsultationInfo () {
        return this.$store.state.publicConsultationInfo
    },
    // currentPatientData(){
    //   return this.$store.state.publicPatient
    // },
    getCountries(){
      return CSP.getCountries();
    },
    getStates(){
      return CSP.getStates(this.currentPatientData.country.code);
    },
  },
  beforeCreate(){
    console.log(this.$route);
    this.$store.dispatch('getConsultationByIdPublic', this.$route.params.event_id).then(response1 => {
        // console.log('consultation: ',response1.data);
        this.doctor_id = response1.data.data.event.doctor_id
        this.consultationDetail = {...this.consultationDetail,...this.activeConsultationInfo.meta};
        this.editEventData.date = new Date(this.activeConsultationInfo.date);
        // custom questions
            if(response1.data.data.event.meta && response1.data.data.event.meta.customQuestions){
            this.userQuestions = JSON.parse(JSON.stringify(response1.data.data.event.meta.customQuestions));
            this.customQuestionsAnswers = new Array(this.userQuestions.length);
            for (let index = 0; index < this.userQuestions.length; index++) {
              this.customQuestionsAnswers[index] = this.userQuestions[index].answer;
            }
          } else {
            // obteniendo preguntas dinámicas
            if(response1.data.data.event.doctor.meta.consultation_questions){
              this.userQuestions = JSON.parse(JSON.stringify(response1.data.data.event.doctor.meta.consultation_questions))
              this.customQuestionsAnswers = new Array(this.userQuestions.length);
            }
            // console.log('preguntas: ',this.userQuestions);
          }
        // end - custom questions
        
        this.$store.dispatch('fetchEventsPublic', response1.data.data.event.doctor_id).then(response => {
            this.$store.dispatch('fetchClinicsPublic',response1.data.data.event.doctor_id);
            console.log(response);
            this.doctor_id = response1.data.data.event.doctor_id
            this.currentDoctorData = JSON.parse(JSON.stringify(response1.data.data.event.doctor));
            var schedulePayload = new Object();
                schedulePayload.doctor_id = response1.data.data.event.doctor_id;
                schedulePayload.date = this.getFormattedDate(new Date());
            this.$store.dispatch('buildSchedule', schedulePayload).then(response => {
            console.log(response);
            }, error => {
                console.error(error);
            }); 
        }, error => {
            console.error(error);
        }); 

        this.$store.dispatch('getUserDataByIdPublic', response1.data.data.event.patient_id).then(response => {
            console.log(response);
            this.currentPatientData = JSON.parse(JSON.stringify(response.data.data.user));
            this.phoneExt = null;
            if(response.data.data.user.meta){
                this.patientMeta = {...this.patientMeta, ...JSON.parse(JSON.stringify(response.data.data.user.meta))};
            }
            this.loading = false;
            }, error => {
                console.error(error);
            }
        ); 
      }, error => {
          console.error(error);
      });  
  },
  mounted(){
  },
  beforeMount(){
    console.log('action: ', this.$route.query.action);
    this.action = this.$route.query.action;

    switch (this.action) {
        case 'edit':
            this.activeTabIndex = 2
            break;
        case 'confirm':
            this.activeTabIndex = 0
            break;
        case 'reconfirm':
            this.activeTabIndex = 0
            break;
        case 'newPatient':
            this.activeTabIndex = 0
            break;
    
        default:
            this.activeTabIndex = 0
            break;
    }
  },
  watch: {
    activeConsultationInfo(newVal, oldVal){
         this.miniCalendar.dates = new Date(newVal.date);
    },
    'editEventData.date': function(newVal, oldVal) {
      
      //   clear hour input
     this.editEventData.hour = "";

      this.$store.dispatch('fetchEventsPublic', this.doctor_id).then(response => {
            console.log(response);
            var schedulePayload = new Object();
                schedulePayload.date = newVal;
                schedulePayload.doctor_id = this.doctor_id;
                schedulePayload.schedule = this.getSchedule(newVal);
            this.$store.dispatch('buildSchedule', schedulePayload).then(response => {
            console.log(response);
            }, error => {
                console.error(error);
            }); 
        }, error => {
            console.error(error);
        }); 
    }
  },
  components: {
    FormWizard,
    TabContent,
    Datepicker,
    vSelect,
    Calendar,
    flatPickr
  }
}
</script>
<style scoped>
body{
        touch-action: manipulation;
    }
</style>